export default __webpack_public_path__ + "static/bride1-46e964b519f053353d3843448bf987ab.png";